import Dashboard from "../../assets/icon/NewsIcons/MainAdmin/NewsGroup"
import {MainAdminMacroeconomicIndicators} from "../../components"
import React, { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import { axiosReq } from "../../commons/axiosReq";
import { useNavigate } from "react-router-dom";

const MainAdminIndicators = () => {

        const [showDeleteModal,setShowDeleteModal] = React.useState(false);
     const [reCheck, setRecheck] = useState(false);
        const [data, setData] = useState();
 
        const [count, setCount] = useState();
  
          let navigate = useNavigate();
    
   
           const GetData = async () => {
                const writersData = await axiosReq("Admins/GetIndex", "get");
                console.log("slm")
                console.log(writersData)
                setData(writersData)
            }
            const auth = async () => {
                    const cookies = new Cookies();
                    var token = cookies.get('token');
                    console.log(token)
                    console.log(cookies.get('role'))
                    if (!token) {
                        navigate("/admin");
                    } else {
                        if( cookies.get('role')=="Admin" )
                       {
            
                           GetData()
                       }
            
                        
                        else {
                            navigate("/admin");
            
                        }
                    }
                }
            useEffect(() => {
        
                auth();
            }, [reCheck]);
    return(
        <div >
            <div className="flex items-center border-b-2 border-borderGray p-[20px]">
                <div className="flex items-center">
                    <div><Dashboard color={'#184548'}/></div>
                    <p className="font-IRANYekanExtra text-[15px] text-mainColor2 mr-[15px]">شاخص‌های کلان اقتصادی</p>
                </div>
            </div>
                {
                    data?
            <div className="pt-[25px] pb-[20px] px-[20px]">
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[0]} time={true} /></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[1]} time={true}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[2]} time={true}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[3]} time={true}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[4]} time={true}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] "><MainAdminMacroeconomicIndicators data={data[5]} time={true}/></div>
                    </div>
                    :
                    null
                }
                <hr className="border-b border-borderGray"/>
                <div className="flex items-center p-[20px] border-b-2 border-borderGray">
                    <div><Dashboard color={'#184548'}/></div>
                    <p className="font-IRANYekanExtra text-[15px] text-mainColor2 mr-[15px]">قیمت کالاهای اساسی</p>
                </div>
                {
                    data?
            <div className="pt-[25px] pb-[200px] px-[20px]">
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[6]} time={false} /></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[7]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[8]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[9]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[10]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[11]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[12]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[13]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminMacroeconomicIndicators data={data[14]} time={false}/></div>
                    <div className="pr-[30px] pl-[70px] py-[20px] "><MainAdminMacroeconomicIndicators data={data[15]}/></div>
                    </div>
                    :
                    null
                }
        </div>
    )
}

export default MainAdminIndicators;